import { Component } from '@angular/core';

@Component({
    selector: 'app-empty',
    template: '<h2>Coming Soon</h2>'
})

export class EmptyComponent {}



// WEBPACK FOOTER //
// ./src/app/shared/components/empty.component.ts